import { Component } from '@angular/core';

@Component({
  selector: 'app-roles-main',
  template: '<router-outlet></router-outlet>',
})
export class RolesMainComponent {}
